import {
  DateFormat,
  formatDate,
} from '@efdigital/ll-addon-content/helpers/format-date';
import picklistTitle from '@efdigital/ll-addon-content/helpers/picklist-title';
import type { CalendarItem } from '@efdigital/ll-addon-data';
import { type TemplateOnlyComponent } from '@ember/component/template-only';

import { ResultsTable } from '../../results-table.gts';

interface Signature {
  Args: {
    calendarItems: CalendarItem[];
  };
  Blocks: {
    title: [calendarItem: CalendarItem];
  };
}

function isAllDay(calendarItem: CalendarItem) {
  return calendarItem.dateType === 'date';
}

const CalendarTable: TemplateOnlyComponent<Signature> = <template>
  <ResultsTable @data={{@calendarItems}}>
    <:header>
      <th>Type</th>
      <th class="mw-50">Title</th>
      <th>Starts</th>
      <th>Ends</th>
    </:header>
    <:row as |calendarItem|>
      <tr>
        <th scope="row">{{picklistTitle
            "calendar-event-type"
            calendarItem.eventType
          }}</th>
        <th scope="row" class="mw-50">{{yield calendarItem to="title"}}</th>
        <td class="font-monospace small">
          <span
            class={{if
              calendarItem.cancelled
              "text-danger text-decoration-line-through"
            }}
          >
            {{#if (isAllDay calendarItem)}}
              {{formatDate calendarItem.starts DateFormat.ShortDate}}
            {{else}}
              {{formatDate calendarItem.starts DateFormat.ShortDateTime}}
            {{/if}}
          </span>
        </td>
        <td class="font-monospace small">
          <span
            class={{if
              calendarItem.cancelled
              "text-danger text-decoration-line-through"
            }}
          >
            {{#if calendarItem.ends}}
              {{#if (isAllDay calendarItem)}}
                {{formatDate calendarItem.ends DateFormat.ShortDate}}
              {{else}}
                {{formatDate calendarItem.ends DateFormat.ShortDateTime}}
              {{/if}}
            {{else}}
              <span class="text-muted">&mdash;</span>
            {{/if}}
          </span>
        </td>
      </tr>
    </:row>
    <:empty>
      <p>No events scheduled for this cohort.</p>
    </:empty>
  </ResultsTable>
</template>;

export default CalendarTable;
